export function convertDateFormat(dateString: string) {
  // Handle invalid date strings
  if (!dateString) return 'Invalid Date';

  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateString);
    return 'Invalid Date';
  }

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Use local time instead of UTC to avoid timezone issues
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const timePeriod = hour >= 12 ? 'pm' : 'am';
  const formattedHour = hour % 12 || 12;

  return `${day} ${month} ${year} at ${formattedHour}:${
    minute < 10 ? '0' : ''
  }${minute} ${timePeriod}`;
}

// show date in dd/mm/yyyy format

export function convertDateFormat1(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function convertDateTime(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const formattedHour = hour % 12 || 12;
  const timePeriod = hour >= 12 ? 'PM' : 'AM';
  return `${day}/${month}/${year} ${formattedHour}:${
    minute < 10 ? '0' : ''
  }${minute} ${timePeriod}`;
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// More robust date parsing function
export function parseServerDate(dateString: string): Date {
  if (!dateString) return new Date();

  // Handle different server date formats
  // Format: "2025-09-28 18:05:21" or "2025-09-28T18:05:21Z" or "2025-09-28"
  let date: Date;

  if (dateString.includes('T')) {
    // ISO format
    date = new Date(dateString);
  } else if (dateString.includes(' ')) {
    // MySQL datetime format: "2025-09-28 18:05:21"
    date = new Date(dateString.replace(' ', 'T'));
  } else {
    // Date only format: "2025-09-28"
    date = new Date(dateString + 'T00:00:00');
  }

  // Validate the date
  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateString);
    return new Date();
  }

  return date;
}

// Enhanced date formatting with better error handling
export function formatOrderDate(dateString: string): string {
  const date = parseServerDate(dateString);

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const timePeriod = hour >= 12 ? 'pm' : 'am';
  const formattedHour = hour % 12 || 12;

  return `${day} ${month} ${year} at ${formattedHour}:${
    minute < 10 ? '0' : ''
  }${minute} ${timePeriod}`;
}
